import React from 'react';
import { Box, Text, HStack, VStack, Avatar } from '@chakra-ui/react';

const Reporter = ({ task }) => {
  return (
    <Box>
      <Text fontSize="12px" fontWeight="600" color="#6B778C" mb={2} textTransform="uppercase">
        REPORTER
      </Text>
      <HStack spacing={2}>
        <Avatar size="sm" name={task?.reporter?.name} w="32px" h="32px" />
        <VStack align="start" spacing={0}>
          <Text fontSize="14px" color="#172B4D" fontWeight="500">
            {task?.reporter?.name || 'Unknown'}
          </Text>
          <Text fontSize="12px" color="#6B778C">
            {task?.reporter?.email || ''}
          </Text>
        </VStack>
      </HStack>
    </Box>
  );
};

export default Reporter;